import { render } from "./readBookClubPage.vue?vue&type=template&id=040a992c&scoped=true"
import script from "./readBookClubPage.vue?vue&type=script&lang=js"
export * from "./readBookClubPage.vue?vue&type=script&lang=js"

import "./readBookClubPage.vue?vue&type=style&index=0&id=040a992c&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-040a992c"]])

export default __exports__